fragment NextStepsNutshellNotificationFragment on FormNextStepsNutshellNotification {
    id
    type
    position
    notifiables {
        ... on User {
            id
            name
        }
    }
    form {
        id
    }
}
